import React from "react";
import { useParams } from "react-router-dom";

export default function Cupon() {
  const {id} = useParams();
  return <div>Cupon {id}</div>;
}
